import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tableScrollViewportFn = /* @__PURE__ */ createRecipe('table-scroll-viewport', {}, [])

const tableScrollViewportVariantMap = {}

const tableScrollViewportVariantKeys = Object.keys(tableScrollViewportVariantMap)

export const tableScrollViewport = /* @__PURE__ */ Object.assign(memo(tableScrollViewportFn.recipeFn), {
  __recipe__: true,
  __name__: 'tableScrollViewport',
  __getCompoundVariantCss__: tableScrollViewportFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tableScrollViewportVariantKeys,
  variantMap: tableScrollViewportVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tableScrollViewportVariantKeys)
  },
  getVariantProps: tableScrollViewportFn.getVariantProps,
})